<template>
  <!-- 新疆安防官网首页 -->
  <section class="container">
    <Header ref="headerRef"></Header>
    <div class="swipeM">
      <!-- 轮播图模块 -->
      <Swiper></Swiper>
      <!-- 通知公告与下载地址 -->
      <div style="margin-left:50px" class="col-45">
        <div class="list-wrapper">
          <div class="swiper-title">
            <div class="ti ti-hover" v-if="show == 1" @click="tab(1)">通知公告</div>
            <div class="ti" @click="tab(1)" v-else>通知公告</div>
            <!--<div class="ti ti-hover" v-if="show==2" @click="tab(2)">下载中心</div>-->
            <!--<div class="ti" @click="tab(2)" v-else>下载中心</div>-->
            <!-- 根据需求隐藏 -->
            <!-- <div class="ti ti-hover" v-if="show==2" @click="tab(2)">公示公告</div>
            <div class="ti" @click="tab(2)" v-else>公示公告</div> -->
          </div>
          <div class="ruleM fadeInUp animated" v-if="show == 1">
            <div class="rule flex-row" v-for="(item, index) in noticeList" :key="index" @click="viewClick3"
              :data-id="item.articleId">
              <div class="col-5">
                <div class="point"></div>
              </div>
              <div class="col-85 overflow pointer" style="font-size:20px;text-align:left;margin-left:10px">
                {{ item.title }}</div>
              <div class="col-15 text-right date" style="font-size:20px">{{ item.createDate }}</div>
            </div>
          </div>
          <!--<div class="ruleM fadeInUp animated" v-else>-->
          <!--<div class="rule flex-row" v-for="(item, index) in downfileList" :key="index" @click="downfile" :data-url="item.fileUrl">-->
          <!--<div class="col-5">-->
          <!--<div class="point"></div>-->
          <!--</div>-->
          <!--<div class="col-85 overflow pointer" style="font-size:20px;text-align:left;margin-left:10px">-->
          <!--{{item.title}}-->
          <!--</div>-->
          <!--<div class="col-15 text-right date" style="font-size:16px">-->
          <!--&lt;!&ndash; <img src="../assets/download.png" alt="" :data-url="item.fileUrl" @click="downfile"> &ndash;&gt;-->
          <!--下载-->
          <!--</div>-->
          <!--</div>-->
          <!--</div>-->
          <div class="ruleM fadeInUp animated" v-else>
            <div class="rule flex-row" v-for="(item, index) in infoList" :key="index" @click="openInfo"
              :data-id="item.textInfoId">
              <div class="col-5">
                <div class="point"></div>
              </div>
              <div class="col-85 overflow pointer" style="font-size:20px;text-align:left;margin-left:10px">
                {{ item.title }}</div>
              <div class="col-15 text-right date" style="font-size:20px">{{ item.createDate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四个栏目一个登陆 -->
    <div class="fourLine">
      <!-- 根据需求暂时弹出未开始报名的提示 -->
      <div class="four-icon" @click="tabClickZc(4)">
      <!-- <div class="four-icon" @click="openPrompt"> -->
        <img src="../assets/icon1.png" alt />
        <div class="four-name">职称继教</div>
      </div>
      <!-- 根据需求修改 -->
      <!-- <div class="four-icon" @click="tabClick('/Professor')">
        <img src="../assets/icon5.png" alt />
        <div class="four-name">专家介绍</div>
      </div> -->
      <div class="four-icon" @click="showGuideDropdown(2)">
        <img src="../assets/icon5.png" alt />
        <div class="four-name">行业培训</div>
      </div>
      <div class="four-icon" @click="tabClick('/Transfer')">
        <img src="../assets/icon2.png" alt />
        <div class="four-name">缴费说明</div>
      </div>
      <div class="four-icon" @click="showGuideDropdown(3)">
        <img src="../assets/icon3.png" alt />
        <div class="four-name">操作指南</div>
      </div>

      <div class="four-icon" @click="tabClick('/Contact')">
        <img src="../assets/icon4.png" alt />
        <div class="four-name">关于我们</div>
      </div>
      <div class="four-login" @click="loginClick">登录</div>
    </div>
    <!-- 行业新闻 与 通知公告 -->
    <!-- <div class="Inner flex-row ListM " id="ListM1">
            <div class="col-50">
                <div class="list-wrapper">
                    <div class="title flex-row">
                        <div class="col-70">
                            行业新闻
                        </div>
                        <div class="text-right col-30 more">
                            <span class="pointer" @click="tabClick('/Dynamic')">
                                更多<Icon type="ios-arrow-forward" /><Icon class="arrow2" type="ios-arrow-forward" />
                            </span>
                        </div>
                    </div>
                    <div class="ruleM fadeInUp animated">
                        <div class="rule flex-row" v-for="(item, index) in workList" :key="index"  @click="viewClick2" :data-id="item.articleId">
                            <div class="col-5">
                                <div class="point"></div>
                            </div>
                            <div class="col-85 overflow pointer">
                                {{item.title}}
                            </div>
                            <div class="col-15 text-right date">
                                {{item.createDate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-50">
                <div class="list-wrapper">
                    <div class="title flex-row">
                        <div class="col-70">
                            通知公告
                        </div>
                        <div class="text-right col-30 more">
                            <span class="pointer" @click="tabClick('/Announcement')">
                                更多<Icon type="ios-arrow-forward" /><Icon class="arrow2" type="ios-arrow-forward" />
                            </span>
                        </div>
                    </div>
                    <div class="ruleM fadeInUp animated">
                        <div class="rule flex-row" v-for="(item, index) in noticeList" :key="index" @click="viewClick3" :data-id="item.articleId">
                            <div class="col-5">
                                <div class="point"></div>
                            </div>
                            <div class="col-85 overflow pointer">
                                {{item.title}}
                            </div>
                            <div class="col-15 text-right date">
                                {{item.createDate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>-->
    <!--协会动态 模块-->
    <!-- <div class="Inner flex-row InterviewM fadeInUp" id="InterviewM" >
            <div class="col-5 ">
                <h1 class="text-center">协会动态</h1>
            </div>
            <div class="col-92 interview-seamless" @click="interviewClick">
              <vue-seamless  :data="interviewList" :class-option="seamlessOptiin" class="" >
                <ul class="interview-ul" :style="{width: ( interviewList.length * 276 ) + 'px'}" >
                  <li class="interviewItem pointer" v-for="(item, index) in interviewList" :key="index" >
                    <div class="img-wrapper text-center">
                      <img :src="item.imgUrl" alt="" :data-id="item.interviewId">
                    </div>
                    <div class="brief text-left">
                      <div class="caption overflow2" :data-id="item.interviewId">
                        {{item.title}}
                      </div>
                      <div class="description overflow3" :data-id="item.interviewId">
                        {{item.summary}}
                      </div>
                    </div>
                  </li>
                </ul>
              </vue-seamless>
            </div>
    </div>-->
    <!--行业法规和下载中心-->
    <!-- <div class="Inner flex-row ListM " id="ListM2">
        <div class="col-50">
          <div class="list-wrapper">
            <div class="title flex-row">
              <div class="col-70">
                行业法规
              </div>
              <div class="text-right col-30 more">
                            <span class="pointer" @click="tabClick('/Rule')">
                                更多<Icon type="ios-arrow-forward" /><Icon class="arrow2" type="ios-arrow-forward" />
                            </span>
              </div>
            </div>
            <div class="ruleM fadeInUp animated">
              <div class="rule flex-row" v-for="(item, index) in ruleList" :key="index"  @click="viewClick" :data-id="item.articleId">
                <div class="col-5">
                  <div class="point"></div>
                </div>
                <div class="col-85 overflow pointer">
                  {{item.title}}
                </div>
                <div class="col-15 text-right date">
                  {{item.createDate}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-50">
          <div class="list-wrapper">
            <div class="title flex-row">
              <div class="col-70">
                下载中心
              </div>
              <div class="text-right col-30 more">
                            <span class="pointer" @click="tabClick('/DownLoad')">
                                更多<Icon type="ios-arrow-forward" /><Icon class="arrow2" type="ios-arrow-forward" />
                            </span>
              </div>
            </div>
            <div class="ruleM fadeInUp animated">
              <div class="rule flex-row" v-for="(item, index) in downfileList" :key="index" @click="downfile" :data-url="item.fileUrl">
                <div class="col-5">
                  <div class="point"></div>
                </div>
                <div class="col-85 overflow pointer">
                  {{item.title}}
                </div>
                <div class="col-15 text-right date">
                  <img src="../assets/download.png" alt="" :data-url="item.fileUrl" @click="downfile">
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>-->
    <!-- 专业课程模块 -->
    <div class="inner-line">
      <!-- 根据需求隐藏 -->
      <!-- <div class="Inner ProfessionalM fadeInUp" id="ProfessionalM">
        <div class="title flex-row">
          <div class="su"></div>
          <div class="col-70">系统集成专业课程试听</div>
          <div class="text-right col-10 more2">
            <div @click="auditionlistClick" data-id="1">
              更多
              <Icon type="ios-arrow-forward" />
            </div>
          </div>
        </div>
        <div class="wrapper flex-row video-list">
          <div
            class="col-45 pointer"
            v-for="(audition, index) in auditionList1"
            :key="index"
            @click="auditionClick"
            data-type="1"
            :data-id="audition.auditionId"
          >
            <img class="cover" :src="audition.cover" alt />
            <div class="name text-center">
              <div class="title2 overflow2 text-left">{{audition.title}}</div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 继续教育课程模块 -->
      <!-- <div class="Inner FurtherM fadeInUp" id="FurtherM">
        <div class="title flex-row">
          <div class="su"></div>
          <div class="col-70">系统集成继续教育课程试听</div>
          <div class="text-right col-10 more2">
            <div @click="auditionlistClick" data-id="2">
              更多
              <Icon type="ios-arrow-forward" />
            </div>
          </div>
        </div>
        <div class="wrapper flex-row video-list">
          <div
            class="col-45 pointer"
            v-for="(audition, index)  in auditionList2"
            :key="index"
            @click="auditionClick"
            data-type="2"
            :data-id="audition.auditionId"
          >
            <img class="cover" :src="audition.cover" alt />
            <div class="name text-center">
              <div class="title2 overflow2 text-left">{{audition.title}}</div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!--专家模块-->
    <!-- <div class="expertM Inner fadeInUp" id="expertM">
      <div class="title" id="asd">专家库</div>
      <div class="wrapper" @click="expertClick">
        <vue-seamless :data="expertList" :class-option="seamlessOptiin">
          <Row class="inner-wrapper" :style="{width: ( expertList.length * 150 ) + 'px'}">
            <Col
              span="3"
              class="expert pointer"
              v-for="(expert, index)  in expertList"
              :key="index"
            >
              <div :data-id="expert.expertId">
                <img class="avatar" :src="expert.picture" alt :data-id="expert.expertId" />
                <div class="name text-center" :data-id="expert.expertId">{{expert.expertName}}</div>
              </div>
            </Col>
          </Row>
        </vue-seamless>
      </div>
    </div>-->
    <Footer></Footer>
  </section>
</template>

<script>
import Header from "./components/Header";
import Swiper from "./components/Swiper";
import Footer from "./components/Footer";
import vueSeamless from "vue-seamless-scroll";
// import { setTab } from '@/lib/config'
import { MessageBox } from 'element-ui';

export default {
  name: "Index",
  data() {
    return {
      isshow: true,
      ruleList: [], //行业法规
      workList: [], //行业新闻列表
      interviewList: [], //协会动态列表
      noticeList: [], //通知公告
      auditionList1: [], //系统集成专业课程试听
      auditionList2: [], //系统集成继续教育课程试听
      expertList: [], //专家库
      downfileList: [], //下载中心
      infoList: [],
      modal2: true,
      show: 1
    };
  },
  created() {
    var that = this;
    that.onload();
    that.setTab();
  },
  mounted() {
    const that = this;
    //页面初始化的时保证可滚动
    $("body").removeAttr("style");
  },
  computed: {
    seamlessOptiin() {
      return {
        direction: 2,
        openWatch: true, //开启数据实时监控刷新dom
        limitMoveNum: 2
      };
    }
  },
  methods: {
    aaa() {
      alert(123);
    },
    openPrompt() {
      MessageBox.alert("本年度职称继教培训还未开始报名，敬请期待！", "提示", {
        confirmButtonText: "确定",
      });
    },
    onload() {
      var that = this;
      var modelData = {};
      this.$http({
        url: that.webhost + "index/list",
        method: "POST",
        data: modelData
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.ruleList = data.data.securityList;
          that.workList = data.data.workList;
          that.interviewList = data.data.interviewList;
          that.auditionList1 = data.data.auditionList1;
          that.auditionList2 = data.data.auditionList2;
          that.expertList = data.data.expertList;
          that.noticeList = data.data.noticeList;
        } else {
          that.$Message.error(data.msg);
        }
      });
      // var modelData = {
      //   page: 1,
      //   size: "8"
      // };
      // this.$http({
      //   url: that.webhost + "attachment/list",
      //   method: "POST",
      //   data: modelData
      // }).then(({ data }) => {
      //   if (data && data.code === 0) {
      //     that.downfileList = data.data.list;
      //   } else {
      //     that.$toast.error(data.msg);
      //   }
      // });


      var data = {
        textInfoColumn: 1,
        page: 1,
        size: '8'
      };
      this.$http({
        url: that.webhost + "textInfo/list",
        method: "POST",
        data: data
      }).then(({ data }) => {
        if (data && data.code === 0) {
          that.infoList = data.data.list;
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    openInfo(e) {
      this.$router.push("/InformationArticle/" + e.currentTarget.dataset.id);
    },
    viewClick3(e) {
      this.$router.push("/AnnouncementArticle/" + e.currentTarget.dataset.id);
    },
    viewClick(e) {
      this.$router.push("/RuleArticle/" + e.currentTarget.dataset.id);
    },
    viewClick2(e) {
      this.$router.push("/WorkArticle/" + e.currentTarget.dataset.id);
    },
    expertClick(e) {
      this.$router.push("/Expert/" + e.target.dataset.id);
    },
    interviewClick(e) {
      this.$router.push("/Interview/" + e.target.dataset.id);
    },
    auditionlistClick(e) {
      this.$router.push("/AuditionList/" + e.currentTarget.dataset.id);
    },
    auditionClick(e) {
      this.$router.push(
        "/Audition/" +
        e.currentTarget.dataset.type +
        "/" +
        e.currentTarget.dataset.id
      );
    },
    downfile(e) {
      window.open(e.currentTarget.dataset.url);
    },
    loginClick() {
      this.$store.commit("login");
    },
    tab(id) {
      console.log(id)
      this.show = id
    },
    showGuideDropdown(n) {
      this.$refs.headerRef.setGuideDropdown(true, n);
    },
    tabClickZc(subjectCode) {
      console.log(this.$store.state.Login.login)
      var that = this;
      if (that.$cookie.get("xjaf-token")) {
        this.$http({
          url: that.webhost + "usersignup/checkSignup",
          method: "GET",
        }).then(({ data }) => {
          if (data && data.code === 0) {
            that.$router.push(`/onlineCourse?subjectCode=${subjectCode}`);
          } else {
            that.$router.push(`/IndustryTraining?subjectCode=${subjectCode}`);
          }
        });
      } else {
        that.$router.push(`/onlineCourse?subjectCode=${subjectCode}`);
      }
    }
  },
  components: {
    Header,
    Swiper,
    Footer,
    vueSeamless
  }
};
</script>

<style scoped>
.Inner {
  width: 45%;
  min-width: 550px;
  /* margin: auto; */
  font-family: "PingFang SC";
}

.title {
  text-align: left;
  font-size: 20px;
  line-height: 72px;
  color: #0078be;
  display: flex;
  align-items: center;
  /* border-bottom: solid 2px #ccc; */
}

.ListM {
  padding: 20px;
}

.ListM .list-wrapper {
  width: 84%;
  margin: auto;
}

.ListM .list-wrapper .title {
  font-size: 23px;
  line-height: 40px;
}

.ListM .ruleM {
  padding: 10px 0;
}

.ListM .rule {
  font-size: 16px;
  text-align: left;
  color: #000;
  height: 30px;
  line-height: 30px;
}

.date {
  color: #666;
}

.date img {
  width: 20px;
  height: 16px;
  cursor: pointer;
}

.point {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #151515;
  margin: auto;
  position: relative;
  top: 11px;
}

.InterviewM {
  padding: 20px 0 25px;
  min-height: 276px;
}

.InterviewM h1 {
  display: table-caption;
  font-size: 30px;
  color: #000;
  line-height: 34px;
  position: relative;
  top: 60px;
  left: 5px;
}

.col-23 {
  width: 23%;
}

.col-92 {
  width: 92%;
}

.InterviewM .img-wrapper img {
  /*width: 96%;*/
  width: 265px;
  height: 150px;
}

.InterviewM .brief {
  width: 85%;
  margin: auto;
  color: #000;
}

.InterviewM .brief .caption {
  font-size: 19px;
  font-weight: bold;
  line-height: 25px;
  padding: 4px 0;
}

.InterviewM .brief .description {
  text-indent: 2rem;
  font-size: 14px;
  height: 62px;
}

.interview-seamless {
  overflow: hidden;
}

.interview-seamless .interview-ul {
  overflow: hidden;
}

.interview-seamless .interview-ul .interviewItem {
  float: left;
  width: 276px;
}

.ProfessionalM,
.FurtherM {
  min-height: 302px;
}

.wrapper {
  width: 100%;
  overflow: hidden;
  padding: 20px 0;
}

.wrapper .col-20 {
  padding: 8px 0 5px;
  transition: 0.2s ease-in-out;
}

.wrapper .col-20:hover {
  border-color: #ddd;
  box-shadow: 1px 1px 2px 1px #ddd;
}

.expert {
  width: 150px;
  padding: 10px 0 5px;
}

.expert:hover {
  border-color: #ddd;
  /*box-shadow: 1px 1px 2px 1px #ddd;*/
}

.expert img {
  width: 85%;
  height: 180px;
}

.expert .name {
  font-size: 19px;
  color: #000;
}

.title2 {
  font-size: 16px;
  width: 92%;
  margin: auto;
  line-height: 21px;
  min-height: 42px;
}

.more {
  font-size: 13px;
  color: #1f1f1f;
}

.cover {
  width: 224px;
  height: 128px;
}

.arrow2 {
  position: relative;
  left: -7px;
}

.more2 {
  font-size: 15px;
  color: #0078be;
  display: flex;
  cursor: pointer;
}

.more2 span {
  position: relative;
  top: 15px;
  height: auto;
  width: auto;
}

.more2 span:hover,
.more span:hover {
  color: #23b8ff;
}

.swipeM {
  display: flex;
  width: 1200px;
  margin: 50px auto;
}

.swiper-title {
  width: 70%;
  margin: 20px auto 40px auto;
  display: flex;
  font-size: 20px;
  justify-content: space-between;
}

.ti-hover {
  background: #0078be;
  color: #ffffff;
}

.ti {
  border-radius: 15px;
  padding: 5px 10px;
  cursor: pointer;
}

.fourLine {
  width: 1200px;
  padding: 0 200px 0 150px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.fourLine img {
  width: 80px;
  height: 80px;
}

.four-icon {
  text-align: center;
  cursor: pointer;
}

.four-name {
  padding-top: 10px;
  font-size: 18px;
  font-weight: bold;
}

.four-login {
  cursor: pointer;
  position: absolute;
  right: 30px;
  width: 35px;
  margin: 0 auto;
  line-height: 35px;
  font-size: 20px;
  word-wrap: break-word;
  background: #0078be;
  color: #ffffff;
  padding: 20px 5px;
  border-radius: 20px;
  display: flex;
  align-items: center;
}

.inner-line {
  width: 1200px;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}

.su {
  width: 10px;
  height: 25px;
  background: #0078be;
  border-radius: 15px;
  margin-right: 10px;
}

.video-list {
  flex-wrap: wrap !important;
  display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue